(() => {
  const exactCorrections = new Map([
    ['cottan', 'cotton'], ['cotten', 'cotton'], ['coton', 'cotton'], ['cottn', 'cotton'],
    ['georget', 'georgette'], ['georgete', 'georgette'], ['gorgette', 'georgette'],
    ['banarsi', 'banarasi'], ['banarshi', 'banarasi'],
    ['duppata', 'dupatta'], ['dupata', 'dupatta'],
    ['ikkat', 'ikat'], ['ikath', 'ikat'],
    ['pochampali', 'pochampally'], ['pochampalli', 'pochampally'],
    ['patachitra', 'pattachitra'], ['patta chitra', 'pattachitra'], ['patchitra', 'pattachitra'],
    ['katha', 'kantha'], ['creap', 'crepe'], ['crape', 'crepe'],
    ['sare', 'saree'], ['sari', 'saree'], ['lehanga', 'lehenga'], ['lengha', 'lehenga'],
    ['embroided', 'embroidered'], ['embrodered', 'embroidered'],
    ['brocad', 'brocade'], ['brocadee', 'brocade'],
    ['chikenkari', 'chikankari'], ['chikan kari', 'chikankari']
  ]);

  const keywordList = [
    'cotton', 'silk', 'pure silk', 'crepe', 'georgette', 'chiffon', 'organza', 'tussar', 'woolen',
    'saree', 'dupatta', 'lehenga', 'skirt', 'kimono', 'kaftan', 'jacket', 'kantha', 'banarasi',
    'brocade', 'ikat', 'pochampally', 'patola', 'pattachitra', 'kalamkari', 'bandhani', 'bandhej',
    'ajrakh', 'bagru', 'batik', 'block print', 'digital print', 'floral', 'embroidered', 'zardozi',
    'chikankari', 'phulkari', 'mirror work', 'gota patti', 'mukesh', 'border', 'trim', 'lace',
    'craft', 'fabric', 'fabric lot', 'scrap fabric', 'home decor', 'lampshade', 'cushion cover'
  ];

  const relatedByKeyword = new Map([
    ['cotton', ['printed cotton saree', 'cotton fabric', 'kantha cotton', 'daily wear cotton']],
    ['silk', ['pure silk saree', 'printed silk saree', 'crepe silk', 'banarasi silk']],
    ['crepe', ['pure crepe silk', 'printed crepe silk', 'crepe saree', 'vintage crepe']],
    ['georgette', ['printed georgette silk', 'georgette saree', 'floral georgette', 'vintage georgette']],
    ['dupatta', ['daily wear dupatta', 'embroidered dupatta', 'silk dupatta', 'banarasi dupatta']],
    ['pattachitra', ['pattachitra saree', 'painted saree', 'odisha craft', 'folk art saree']],
    ['banarasi', ['brocade banarasi', 'banarasi silk', 'woven saree', 'zari saree']],
    ['ikat', ['pochampally ikat', 'patola saree', 'ikat silk', 'woven ikat']],
    ['craft', ['scrap fabric', 'fabric lot', 'borders and trims', 'upcycle fabric']],
    ['fabric', ['fabric lot', 'scrap fabric', 'silk fabric', 'craft fabric']]
  ]);

  const normalizeSpaces = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const normalize = (value) => normalizeSpaces(value).toLowerCase();

  const levenshtein = (a, b) => {
    if (Math.abs(a.length - b.length) > 3) return 99;
    const row = Array.from({ length: b.length + 1 }, (_, index) => index);
    for (let i = 1; i <= a.length; i += 1) {
      let previous = row[0];
      row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const temp = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1));
        previous = temp;
      }
    }
    return row[b.length];
  };

  const getSuggestion = (query) => {
    const lower = normalize(query);
    if (!lower) return '';
    if (exactCorrections.has(lower)) return exactCorrections.get(lower);
    const words = lower.split(' ');
    const correctedWords = words.map((word) => exactCorrections.get(word) || word);
    const phraseCorrected = correctedWords.join(' ');
    if (phraseCorrected !== lower) return phraseCorrected;
    let best = { term: '', score: 99 };
    keywordList.forEach((term) => {
      const score = levenshtein(lower, term);
      if (score < best.score) best = { term, score };
    });
    const maxScore = lower.length <= 5 ? 1 : 2;
    return best.score <= maxScore ? best.term : '';
  };

  const buildSearchUrl = (query) => {
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.pathname + url.search;
  };

  const ensureHiddenInput = (form, name, value) => {
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    const isSearchForm = action.includes('/search') || form.querySelector('input[name="q"]');
    if (!isSearchForm) return;
    if (!form.querySelector('input[name="type"]')) ensureHiddenInput(form, 'type', 'product');
    ensureHiddenInput(form, 'options[prefix]', 'last');
  }, true);

  const addStyles = () => {
    if (document.getElementById('sv-search-guard-styles')) return;
    const style = document.createElement('style');
    style.id = 'sv-search-guard-styles';
    style.textContent = `
      .sv-search-suggest{margin-top:16px;padding:14px 16px;border:1px solid rgba(31,22,17,.22);border-radius:8px;background:#fff;color:#1F1611;box-shadow:0 8px 24px rgba(31,22,17,.08)}
      .sv-search-suggest__mean{margin:0;font-weight:800;line-height:1.4}.sv-search-suggest__mean a{color:#B04526;text-decoration:underline;text-underline-offset:3px;font-weight:950}
      .sv-search-suggest__related{display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-top:10px}.sv-search-suggest__related span{font-size:12px;font-weight:900;text-transform:uppercase;letter-spacing:.08em;color:rgba(31,22,17,.68)}
      .sv-search-suggest__chip{display:inline-flex;padding:7px 10px;border:1px solid rgba(31,22,17,.22);border-radius:999px;background:#FDF6EC;color:#1F1611;text-decoration:none;font-size:13px;font-weight:850}.sv-search-suggest__chip:hover{background:#FFC857;color:#1F1611}
      .sv-search__exact-note{margin:0 0 16px;padding:10px 12px;border-left:4px solid #E8505B;background:#fff;color:#1F1611;font-size:13px;font-weight:800;line-height:1.4}
      .sv-result-card[data-sv-checking="true"]{opacity:.55}.sv-result-card[hidden]{display:none!important}.sv-search__no-close{grid-column:1/-1;padding:24px;border:1px solid rgba(31,22,17,.22);border-radius:8px;background:#fff;font-weight:850;line-height:1.5}
      @media(max-width:749px){.sv-search-suggest{padding:12px;margin-top:14px}.sv-search-suggest__related{gap:7px}.sv-search-suggest__chip{font-size:12px;padding:7px 9px}}
    `;
    document.head.appendChild(style);
  };

  const createChip = (text) => {
    const chip = document.createElement('a');
    chip.className = 'sv-search-suggest__chip';
    chip.href = buildSearchUrl(text);
    chip.textContent = text;
    return chip;
  };

  const injectSuggestion = () => {
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    const params = new URLSearchParams(window.location.search);
    const query = normalizeSpaces(params.get('q'));
    if (!query || document.querySelector('.sv-search-suggest')) return;
    const suggestion = getSuggestion(query);
    const lower = normalize(query);
    const relatedKey = Array.from(relatedByKeyword.keys()).find((key) => lower.includes(key) || suggestion === key);
    const related = relatedKey ? relatedByKeyword.get(relatedKey) : [];
    if (!suggestion && !related.length) return;
    addStyles();
    const box = document.createElement('div');
    box.className = 'sv-search-suggest';
    if (suggestion && suggestion !== lower) {
      const line = document.createElement('p');
      line.className = 'sv-search-suggest__mean';
      line.append('Did you mean ');
      const link = document.createElement('a');
      link.href = buildSearchUrl(suggestion);
      link.textContent = suggestion;
      line.append(link, '?');
      box.appendChild(line);
    }
    if (related.length) {
      const relatedWrap = document.createElement('div');
      relatedWrap.className = 'sv-search-suggest__related';
      const label = document.createElement('span');
      label.textContent = 'Related searches';
      relatedWrap.appendChild(label);
      related.slice(0, 4).forEach((term) => relatedWrap.appendChild(createChip(term)));
      box.appendChild(relatedWrap);
    }
    const countRow = document.querySelector('.sv-search__count-row') || document.querySelector('.sv-search__count');
    const form = document.querySelector('.sv-search__form');
    if (countRow) countRow.insertAdjacentElement('afterend', box);
    else if (form) form.insertAdjacentElement('afterend', box);
  };

  const run = () => {
    injectSuggestion();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();